import React from 'react';
import './ComingSoonBanner.css'; // Import the CSS styles

const ComingSoonBanner = () => (
    <div className="angled-banner">
        <span>Coming Soon</span>
    </div>
);

export default ComingSoonBanner;